import { useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { selectProductPdfDownload, selectProductPdfPrint } from '@client/product/redux/productPdf/redux';

export type UseProductPdfDataReturnType = {
  printPdf: RemoteRecord<any>;
  downloadPdf: RemoteRecord<any>;
};

export const useProductPdfData = (): UseProductPdfDataReturnType => ({
  printPdf: useSelector(selectProductPdfPrint),
  downloadPdf: useSelector(selectProductPdfDownload),
});
